// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_dNO","cls2":"AnalyticsV2NavBar-cls2_1cf AnalyticsV2NavBar-cls1_dNO"};